import { render, staticRenderFns } from "./ModalItem.vue?vue&type=template&id=633b7547&scoped=true&lang=pug&"
import script from "./ModalItem.vue?vue&type=script&lang=js&"
export * from "./ModalItem.vue?vue&type=script&lang=js&"
import style0 from "./ModalItem.vue?vue&type=style&index=0&id=633b7547&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633b7547",
  null
  
)

export default component.exports